import React from 'react';
import type { ThemeColorSchemeType } from '@/stores/builder';
import { useFreeGiftWizard } from '@/hooks/use-free-gift-wizard';
import { getPromoGiftCaps } from '@/lib/promotions';
import FreeGiftList from '@/components/sections/builder/elements/header/header/cart-dropdown/free-gift-list';

type FreeGiftWizardType = ReturnType<typeof useFreeGiftWizard>;

export default function GiftWizard({
  wizard,
  token,
  locationId,
  colorScheme,
  setDrawerView,
}: {
  wizard: FreeGiftWizardType;
  token: string;
  locationId: string;
  colorScheme?: ThemeColorSchemeType;
  setDrawerView: React.Dispatch<
    React.SetStateAction<'cart' | 'voucher' | 'gift' | 'active_offers'>
  >;
}) {
  if (!wizard.open || !wizard.currentPromo) return null;

  const { globalMax, groupCaps } = getPromoGiftCaps(wizard.currentPromo);

  const handleNextStep = () => {
    if (wizard.hasNext) {
      wizard.goNext();
      setDrawerView('gift');
    } else {
      wizard.finish();
      setDrawerView('cart');
    }
  };

  return (
    <FreeGiftList
      drawerView='gift'
      token={token}
      promotion={wizard.currentPromo}
      setDrawerView={(v) => {
        if (v === 'cart') {
          wizard.setOpen(false);
        }
        setDrawerView(v);
      }}
      maxQty={globalMax}
      capsByGroup={groupCaps}
      colorScheme={colorScheme}
      initialSelectedGifts={wizard.initialSelectedForCurrent}
      locationId={locationId}
      wizardMode
      onSaveGift={(data) => {
        wizard.commitOne(wizard.currentPromoId, data);
        handleNextStep();
      }}
      onNextStep={handleNextStep}
    />
  );
}
